import script from "./ConfirmDeleteAtmCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDeleteAtmCardModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__